import { render, staticRenderFns } from "./nutritionalAnalysis2.vue?vue&type=template&id=1d11840c&scoped=true"
import script from "./nutritionalAnalysis2.vue?vue&type=script&lang=js"
export * from "./nutritionalAnalysis2.vue?vue&type=script&lang=js"
import style0 from "./nutritionalAnalysis2.vue?vue&type=style&index=0&id=1d11840c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d11840c",
  null
  
)

export default component.exports